import { LangProps } from '@/shared/props';
import styled from 'styled-components';

export const StyledAuditText = styled.div<LangProps>`
  gap: 12px;
  align-items: center;
  display: flex;
  flex-direction: ${(props) => (props.$isRtl ? 'row-reverse' : 'row')};
`;
